var map = {
	"./ar.json": 8811,
	"./bn.json": 1103,
	"./es.json": 6171,
	"./fr.json": 7437,
	"./ht.json": 9298,
	"./ko.json": 1695,
	"./pl.json": 1207,
	"./ru.json": 1469,
	"./ur.json": 9236,
	"./zh-CN.json": 2767
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4538;